
'use client';

import { useEffect } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export function CheckoutPageAnimator() {

  useEffect(() => {
    const timer = setTimeout(() => {
        const tl = gsap.timeline({
            delay: 0.1,
            onComplete: () => {
                ScrollTrigger.refresh();
            },
        });

        tl
          .to('.gsap-checkout-form', { opacity: 1, y: 0, duration: 0.8, ease: 'power3.out' }, "-=0.6")
          .to('.gsap-checkout-summary', { opacity: 1, y: 0, duration: 0.8, ease: 'power3.out' }, "-=0.6");
          
    }, 0);


    return () => {
      clearTimeout(timer);
      ScrollTrigger.getAll().forEach(trigger => trigger.kill());
    };
  }, []);

  return null;
}
